var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EquipPerformanceComponent"},[_c('equip-performance',{ref:"equipPerformance",attrs:{"systemTypeCode":_vm.systemTypeCode,"name":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }